export default __webpack_public_path__ + "static/media/GlassesSearchIcon.4ffb9029.svg";